module.exports = __webpack_public_path__ + "img/IMG_1539_L_WoodMatted.a891e606.jpg";